import React from 'react'

export const linkReg = /(?:(?:(?:http|https):\/\/)|www\.)[a-zA-Z.0-9-._~:/?#@!$&'()*+,;%=]+/g

export const getStrURL = (str: string | undefined) => str?.match(linkReg) || []

export const parseHTMLTxtWithLinks = (message: string | undefined) => {
  const links = getStrURL(message)
  const messageArr = message?.split(linkReg).reduce((a: any[], txt: string, i: number) => {
    a.push(txt)
    if (links.length >= i + 1) {
      a.push(
        <a
          key={i}
          href={links[i].indexOf('www') === 0 ? `https://${links[i]}` : links[i]}
          rel="noopener noreferrer"
          target="_blank"
        >
          {links[i]}
        </a>
      )
    }
    return a
  }, [])
  return messageArr
}
